import { Directive } from '@angular/core';
import { classes } from '@budgets/ui/helm/utils';

@Directive({ selector: '[hlmSelectValuesContent],hlm-select-values-content' })
export class HlmSelectValuesContent {
	constructor() {
		classes(() => 'flex gap-1');
	}
}
